import {
  WIDGET_REVIEWS_PAGE,
  STANDARD_REVIEWS_PAGE,
  COMPACT_WIDGET_REVIEWS_PAGE,
} from 'constants/Profiles';

const getProfileReviewsPageType = widgetType => {
  if (!widgetType) return STANDARD_REVIEWS_PAGE;
  const widgetNumber = parseInt(widgetType, 10) || 1;

  switch (widgetNumber) {
    case 2:
      return COMPACT_WIDGET_REVIEWS_PAGE;
    case 1:
    default:
      return WIDGET_REVIEWS_PAGE;
  }
};

export default getProfileReviewsPageType;
